var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H15C15.8284 1.5 16.5 2.17157 16.5 3V4.93934C16.5 5.33716 16.342 5.7187 16.0607 6L11.25 10.8107L11.25 12.75C11.25 12.9489 11.171 13.1397 11.0303 13.2803L8.03033 16.2803C7.81583 16.4948 7.49324 16.559 7.21299 16.4429C6.93273 16.3268 6.75 16.0533 6.75 15.75V10.8107L1.93934 6C1.65803 5.71869 1.5 5.33716 1.5 4.93934V3ZM15 3H3V4.93934L7.81066 9.75C8.09196 10.0313 8.25 10.4128 8.25 10.8107V13.9393L9.75 12.4393V10.8107C9.75 10.4128 9.90803 10.0313 10.1893 9.75L15 4.93934V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.aaa62e8298ffcd4a676c8ab2218d4089.svg";
export { ForwardRef as ReactComponent };